import { BaseUrlService } from './base-url.service';

export class StorageService {
    static $inject: string[] = ['$http', 'BaseUrlService'];

    private baseUrl: any;

    constructor(
        private $http: ng.IHttpService,
        private _baseUrlService: BaseUrlService,
    ) {
        this.baseUrl = _baseUrlService.getBaseUrl();
    }

    getBase64(path: any) {
        return this.$http.get(this.baseUrl + '/storage/get-base64/' + encodeURIComponent(path));
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/storage.service.ts